<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div>
  <div class="tooltip-container">
    <table>
      <tr *ngIf="gearset">
        <td class="perk-icon-col" rowspan="2">
          <img
            alt="{{ gearset.displayProperties.name }}"
            class="perk-icon"
            src="https://bungie.net/{{ gearset.displayProperties.icon }}" />
        </td>
      </tr>
      <tr *ngIf="gearset">
        <td>
          <span>{{ gearset.displayProperties.name }}</span>
        </td>
      </tr>
      <tr *ngIf="gearset">
        <td colspan="2">
          {{ gearset.displayProperties.description }}
        </td>
      </tr>
    </table>
  </div>
</div>
